import { Box, styled } from '@mui/material';

export const IvStatusIcon = styled(Box)<{ verified?: string; inprogress?: string }>(({ verified, inprogress }) => ({
  width: '16px',
  height: '16px',
  display: 'flex',
  flex: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: inprogress == 'true' ? '#8d97a4' : verified == 'true' ? '#008A06' : '#E31B0C',
  borderRadius: '50%',
  fontSize: '10px',
  color: inprogress == 'true' ? '#8d97a4' : verified == 'true' ? '#008A06' : '#E31B0C',
  '&::after': {
    content: '"IV"'
  }
}));
